<template>
  <filter-summary
    icon="store"
    title="店舗"
    :scroll-to-id="scrollToId"
    v-on="$listeners"
    :errors="errors"
  >
    <div>対象：{{ base.stores.length }}店舗</div>
    <div>比較：{{ compare.stores.length }}店舗</div>
  </filter-summary>
</template>

<script>
import FilterSummary from '@/components/FilterSummary.vue'

/**
 * 「店舗」の目次
 */
export default {
  components: { FilterSummary },
  props: {
    scrollToId: String,
    base: {
      type: Object,
      default: () => ({
        stores: [],
      }),
    },
    compare: {
      type: Object,
      default: () => ({
        stores: [],
      }),
    },
    errors: {
      type: Array,
    },
  },
  computed: {
    count() {
      return this.stores.length
    },
    listeners() {
      return {
        ...this.$listeners,
      }
    },
  },
}
</script>
